<div class="app-empty-inbox">
  <app-image class="app-empty-inbox-image" name="empty-inbox"></app-image>
  <span class="app-empty-inbox-text" translate>{{ textCode }}</span>
</div>
